export default [{
  name: 'adminIdentity',
  namespaced: true,
  state: {
    userRoles: '',
    challenge: {}
  },
  mutations: {
    userroles (state, obj) {
      state.userRoles = obj
    },
    challenge (state, obj) {
      if (!obj) { obj = '' }
      state.challenge = obj
      localStorage.setItem('challenge', JSON.stringify(obj))
    },
  },
  getters: {
    userroles (state) {
      return state.userRoles
    },
    challenge (state) {
      return state.challenge
    }
  }
}]
